import { Injectable } from "@angular/core";
import { LocalStoreService } from "./local-store.service";
import { jwtDecode } from "jwt-decode"; // ✅ Correct import for jwt-decode v4+
import { ConvertToLocalTimePipe } from "../pipes/ConvertToLocalTime.pipe";
// import { log } from 'console';

@Injectable({
  providedIn: "root",
})
export class GlobalDataService {
  constructor(private store: LocalStoreService) {}

  getAccessToken() {
    return this.store?.getItem("accessToken");
  }

  getTimeZoneOffset(): string {
    const token = this.getAccessToken();
    if (!token) return ""; // Default to UTC if token is missing

    try {
      const decodedToken: any = jwtDecode(token);
      return decodedToken.UtcOffSet || ""; // Read timezone offset from claim
      //return Number(decodedToken.timeZone) || 0; // Read timezone offset from claim
    } catch (error) {
      console.error("Error decoding token:", error);
      return "";
    }
  }

  getTimeZone(): string {
    const token = this.getAccessToken();
    if (!token) return ""; // Default to UTC if token is missing

    try {
      const decodedToken: any = jwtDecode(token);
      return decodedToken.TimeZone || ""; // Read timezone offset from claim
      //return Number(decodedToken.timeZone) || 0; // Read timezone offset from claim
    } catch (error) {
      console.error("Error decoding token:", error);
      return "";
    }
  }

  ChangeTimeZoneDateTimeFormat(date: Date){
    const formatedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}T${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}.000`;

    return formatedDate;
  }

  getdir() {
    return this.store?.getItem("dir");
  }

  getCurrencySymbol() {
    let setting = this.store.getItem("setting");
    return setting?.currencySymbol;
  }

  getAppName() {
    let setting = this.store.getItem("setting");
    return setting?.appName;
  }

  getCopyright() {
    let setting = this.store.getItem("setting");
    return setting?.copyright;
  }

  getCurrentTanantName() {
    let tenantName = this.store?.getItem("tenantName");
    return tenantName;
  }

  getCurrentTanantId() {
    let tenantId = this.store?.getItem("tenantId");
    return tenantId;
  }
  getLogoPicture() {
    let logo = this.store?.getItem("logoPicture");
    return logo;
  }

  getLoaderPicture() {
    let loaderlogo = this.store?.getItem("loaderPicture");
    return loaderlogo;
  }

  getbackgroundImage1Picture() {
    let bg1 = this.store?.getItem("backgroundImage1PictureUrl");
    return bg1;
  }

  getbackgroundImage2Picture() {
    let bg2 = this.store?.getItem("backgroundImage2PictureUrl");
    return bg2;
  }

  getbackgroundImage3Picture() {
    let bg3 = this.store?.getItem("backgroundImage3PictureUrl");
    return bg3;
  }

  getbackgroundImage4Picture() {
    let bg4 = this.store?.getItem("backgroundImage4PictureUrl");
    return bg4;
  }

  getTodayFormatedDate() {
    const today = new Date();
    const year = today.getFullYear().toString(); // Get the last two digits of the year
    const month = (today.getMonth() + 1).toString().padStart(2, "0"); // Add leading zero if needed
    const day = today.getDate().toString().padStart(2, "0"); // Add leading zero if needed
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }

  convertToDateTimeLocalFormat(dateString: string): string {
    if (!dateString) return "";

    // Convert input string to Date object
    const date = new Date(dateString);

    // Format to 'YYYY-MM-DDTHH:mm' (required for datetime-local)
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  downloadFileOnFrontEnd(data: any, fileName: string, contentType: string) {
    // Convert ArrayBuffer to Base64

    // Create a data URI for the file
    const dataUri = `data:${contentType};base64,${data}`;

    // Create an anchor element and trigger the download
    const anchor = document.createElement("a");
    anchor.href = dataUri;
    anchor.download = fileName;
    anchor.style.display = "none";
    document.body.appendChild(anchor); // Append the anchor to the DOM
    anchor.click(); // Trigger the click to start the download
    document.body.removeChild(anchor); // Remove the anchor from the DOM
  }

  getCompanyTimeZone() {
    
    let setting = this.store.getItem("setting");
    return setting?.timeZone;
  }
}
